import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService, AuthType } from '../services/auth.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { getEspOrgId } from '../services/esp-auth.service';
import { environment } from '../../../environments/environment';
import { SignInProposeService } from '../modals/signin-propose/signin-propose.service';
import { Addon } from '../models/addon.model';

@Injectable({ providedIn: 'root' })
export class ProfileCompletedGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
    private http: HttpClient, private signInProposalService: SignInProposeService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!environment.forceProfileCompletion) {
      return Promise.resolve(true);
    }
    if (this.auth.idenediGroupId && this.auth.isLoggedIn()) {
      return this.checkIfProfileCompleted(state.url)
    }
    return Promise.resolve(true);
  }

  checkIfProfileCompleted(routeUrl) {
    // return Promise.resolve(true);

    return this.auth.getAddonsAuth(this.auth.idenediGroupId).pipe(
      map(addons => { return addons.find(a => a.Type == AuthType.ESP) }),
      switchMap(espAddon => {
        if (!espAddon) {
          return of(true);
        }
        return this.checkProfileStatus(espAddon, this.auth.getCurrentUserId()).pipe(map(res => {
          if (res instanceof HttpErrorResponse) {
            return true;
          }
          const profileCompleted = res.body == 'COMPLETE' || res.body == "IN-COMPLETE-BY-ADMIN";
          if (profileCompleted) {
            return true;
          }
          else {
            this.signInProposalService.setRedirectPath(routeUrl);
            this.router.navigate(['groups/profile'])
            return false;
          }
        }),
          catchError(err => {
            return of(true);
          }))
      })
    )


  }

  checkProfileStatus(espAddon: Addon, applicantId: string): Observable<any> {
    const orgId = getEspOrgId(espAddon)
    return this.http.get<Observable<any>>('/applicant/profileStatus/' + applicantId + '/' + orgId, { observe: 'response', headers: this.auth.buildAuthHeader(AuthType.ESP) })
  }
}
